import { LayoutRenderSchemaData } from './cv-layout-render.model';
import { SchemaDictionaryNames, COMPONENTS, LAYOUTS } from './schemas';

export class LayoutDictionary {

	/**
	 * Generate Layout Dicitionary to use in the rerender component
	 * ToDo:
	 * - Make it atuomatically load from the files
	 */
	static generateLayoutDictionary(schema: string): LayoutRenderSchemaData {
		const schemaName = SchemaDictionaryNames[schema];
		const item = new LayoutRenderSchemaData();
		const layout = LAYOUTS[schemaName];
		const components = COMPONENTS[schemaName];

		item.layout = layout;
		item.components = components;

		return item;
	}
}